import { t } from 'i18next';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  FetchCertainPaymentMethodRequest,
  FetchCertainPaymentMethodResponse,
} from '@cashier/cashier-api-model';

import {
  fetchCertainPaymentMethodFailure,
  fetchCertainPaymentMethodStart,
  fetchCertainPaymentMethodSuccess,
  refetchCertainPaymentMethodFailure,
  refetchCertainPaymentMethodStart,
  refetchCertainPaymentMethodSuccess,
} from './paymentMethod.slice';

export const fetchCertainPaymentMethodEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(fetchCertainPaymentMethodStart.type),
    switchMap((action: { payload: FetchCertainPaymentMethodRequest }) =>
      Api.fetchCertainPaymentMethod(action.payload).pipe(
        map((data: FetchCertainPaymentMethodResponse) =>
          fetchCertainPaymentMethodSuccess(data),
        ),
        catchError((error) => {
          const statusCodeErrorMessages = {
            400: t('finalScreenError.badRequest'),
            404: t('finalScreenError.methodNotFound'),
            500: t('finalScreenError.internalServerError'),
          };

          const errorMessage =
            error.status in statusCodeErrorMessages
              ? statusCodeErrorMessages[error.status]
              : t('finalScreenError.internalServerError');

          return of(fetchCertainPaymentMethodFailure(errorMessage));
        }),
      ),
    ),
  );

export const fetchCertainPaymentMethod = (
  data: FetchCertainPaymentMethodRequest,
) => ({
  type: fetchCertainPaymentMethodStart.type,
  payload: data,
});

export const refetchCertainPaymentMethodEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(refetchCertainPaymentMethodStart.type),
    switchMap((action: { payload: FetchCertainPaymentMethodRequest }) =>
      Api.fetchCertainPaymentMethod(action.payload).pipe(
        map((data: FetchCertainPaymentMethodResponse) =>
          refetchCertainPaymentMethodSuccess(data),
        ),
        catchError((error) => {
          const statusCodeErrorMessages = {
            400: t('finalScreenError.badRequest'),
            404: t('finalScreenError.methodNotFound'),
            500: t('finalScreenError.internalServerError'),
          };

          const errorMessage =
            error.status in statusCodeErrorMessages
              ? statusCodeErrorMessages[error.status]
              : t('finalScreenError.internalServerError');

          return of(refetchCertainPaymentMethodFailure(errorMessage));
        }),
      ),
    ),
  );

export const refetchCertainPaymentMethod = (
  data: FetchCertainPaymentMethodRequest,
) => ({
  type: refetchCertainPaymentMethodStart.type,
  payload: data,
});
